import { UserRole } from '../types/index.js';
/**
 * Default Admin Role for Admin Console.
 */
export const defaultRole = {
    id: 'ac-admin-id',
    name: UserRole.Admin,
    description: 'Admin role for Logto.',
};
